import { useState, useCallback } from 'react';
import { userIsPending } from '../../api';

export const useShouldOpenUserActivationModal = () => {
    const [checkUserIsPending, setCheckUserIsPending] = useState(true);

    return useCallback(async () => {
        if (!checkUserIsPending) return false;

        try {
            const isUserPending = await userIsPending();
            if (isUserPending !== checkUserIsPending) {
                setCheckUserIsPending(isUserPending);
            }

            return isUserPending;
        } catch (error) {
            return false;
        }
    }, [checkUserIsPending]);
};
